import { render, staticRenderFns } from "./MyPlans.vue?vue&type=template&id=3115a7ea&scoped=true&lang=pug"
import script from "./MyPlans.vue?vue&type=script&lang=js"
export * from "./MyPlans.vue?vue&type=script&lang=js"
import style0 from "./MyPlans.vue?vue&type=style&index=0&id=3115a7ea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115a7ea",
  null
  
)

export default component.exports